import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from 'rxjs';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class QualApiService {
  public QUAL_REQUEST = environment.apiUrl + '/v2/api/';
  public httpPostOptions = {
    headers: new HttpHeaders().set('Content-Type', 'application/json'),
    withCredentials: true,
    params:{}
  };
  constructor(private http:HttpClient, private apiRequest: ApiRequestService) { }
  
  getInterviewList(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/api/getQualInterviewList',data);
    // return this.http.post(this.QUAL_REQUEST + "getQualInterviewList", data, this.httpPostOptions)
  }

  getInterviewDetails(data): Observable<any>{
    return this.apiRequest.request('POST','/v2/api/getQualInterviewReports',data);
    // return this.http.post(this.QUAL_REQUEST + "getQualInterviewReports", data, this.httpPostOptions)
  }


}
